import axios from 'axios'

export const apiName = "courses";
export const coursePath = "/courses/";
export const publicCoursePath = "/courses/public/";
export const lecturePath = "/lectures/"
export const userLecturePath = "/users/lectures/"
export const userCoursePath = "/users/courses/";
export const myLearningPath = "/users/courses/myLearning"
export const userCourseUpdatePath = "/users/courses/update/"
export const configUI = "/configUI/"
export const usersPath = "/users/"
export const fqasPath = "/faqs/"


